import InputOtp from "@/components/shared/InputOtp";
import AUTH from "@/redux/Auth";
import { useAppDispatch } from "@/redux/store";
import { FormikProps } from "formik";
import React, { useState } from "react";

const index = ({
  formikProps,
  mobile,
}: {
  formikProps: FormikProps<any>;
  mobile: string;
}) => {
  const dispatch = useAppDispatch();
  const [send, setResend] = useState(false);
  return (
    <div>
      <p className=" text-16 text-textColor font-[500] my-10">
        سيصلك رساله نصية علي الواتسأب يوجد بها 4 ارقام قم بادخالهم في هذا الحقل
        لتأكيد حسابك
      </p>
      <InputOtp FormikProps={formikProps} name="code" />
      <div className="flex gap-3 text-14 text-white my-10">
        لم أتلق الرمز{" "}
        <div className="flex flex-col gap-3">
          <span
            className=" text-primaryColor cursor-pointer"
            onClick={() => {
              dispatch(
                AUTH.thunks.doResendCode({
                  data: {
                    mobile,
                    //  type: "verify"
                  },
                })
              ).then((res) => {
                res.meta.requestStatus === "fulfilled" && setResend(true);
              });
            }}
          >
            اعادة الارسال
          </span>{" "}
          {/* {send && (
            <span className="text-sm text-white">
              تم ارسال كود التفعيل مرة أخري
            </span>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default index;
